import { extendClient, ExtendedPrismaClient } from "./extended-client";
import { prismaClientRaw } from "./raw-client";
export * from "@prisma/client";

const prismaGlobal = global as typeof global & {
    prisma?: ExtendedPrismaClient;
};

export { extendClient };

// @ts-expect-error
export const prisma: ExtendedPrismaClient =
    typeof window !== "undefined"
        ? undefined
        : prismaGlobal.prisma || extendClient(prismaClientRaw);
if (process.env.NODE_ENV !== "production") {
    prismaGlobal.prisma = prisma;
}

export enum ExchangeTransactionType {
    DEPOSIT = "DEPOSIT",
    WITHDRAWAL = "WITHDRAWAL",
    BANK_WITHDRAWAL = "BANK_WITHDRAWAL",
    TRADE = "TRADE",
    STAKING = "STAKING",
    UNSTAKING = "UNSTAKING",
    REWARD = "REWARD",
    BONUS = "BONUS",
    OTHER = "OTHER",
    BUY = "BUY",
}
